import {create} from 'zustand';

interface PageTitleStore {
  pageTitle: string;
  setPageTitle: (title: string) => void;
}

export const usePageTitleStore = create<PageTitleStore>(set => ({
  pageTitle: '',
  setPageTitle: title => set({pageTitle: title}),
}));
